import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
 selector: 'formly-input-switch',
 template: `
 <div class="d-flex align-items-center">
  <p-toggleswitch [formControl]="formControl" [formlyAttributes]="field"></p-toggleswitch>
  <label class="ml-3">{{to.label|translate}}</label>
 </div>

  `,
  imports: [TranslateModule, FormlyModule, ToggleSwitchModule, ReactiveFormsModule],
})
export class FormlyInputSwitchComponent extends FieldType {}
